import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const Nueve = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Pestle</Paragraph>
        <Text className='BaseText2'>Political, economic, social, technological, legal, and environmental factors can affect iMoAge. To evaluate which choices have a high probability of being influenced, we made our PESTLE analysis which is shown in the next figure:</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-33.png'/>
          <p><b>Fig. 8</b>  Political, economic, social, technological, legal and environmental (PESTLE) analysis made for iMoAge.</p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Nueve;
